import { render, staticRenderFns } from "./EditUserGroup.vue?vue&type=template&id=37685e34&"
import script from "./EditUserGroup.vue?vue&type=script&lang=js&"
export * from "./EditUserGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditUserGroup.vue?vue&type=style&index=0&id=37685e34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports